<script>
    //Boostrap
    import "bootstrap/dist/css/bootstrap.min.css";
    import "bootstrap/dist/js/bootstrap.bundle.min.js";
    //Route
    import Router from "svelte-spa-router";
    import { link } from "svelte-spa-router";
    import { push } from "svelte-spa-router";
    //import Pagine
    import Home from "./Home.svelte";
    import WiFi from "./components/WiFi.svelte";
    import Fibra from "./components/Fibra.svelte";
    import ProdottiServizi from "./components/ProdottiServizi.svelte";
    import Voip from "./components/Voip.svelte";
    import Iot from "./components/iot.svelte";
    import Software from "./components/Software.svelte";
    // Funzione per impostare il titolo della pagina
    function setPageTitle(title) {
        document.title = title;
    }

    //definizione menu

    const routes = {
        "/": Home,
        "/wi-fi": WiFi,
        "/fibra": Fibra,
        "/voip": Voip,
        "/iot": Iot,
        "/software": Software,
    };
</script>

<nav
    class="navbar navbar-expand-md fixed-top border-0 shadow-lg navbar-shrink py-3 navbar-light"
    id="mainNav"
>
    <!-- svelte-ignore a11y-missing-attribute -->
    <div class="container">
        <a href="/" use:link
            ><img
                class="pulse animated"
                src="assets/img/brands/LIRS_file-07.svg"
                style="width: 50px;"
            /></a
        ><a class="navbar-brand d-flex align-items-center" href="/" use:link
            ><img src="assets/img/slogan.svg" width="168" height="33" /></a
        ><button
            data-bs-toggle="collapse"
            class="navbar-toggler border-0"
            data-bs-target="#navcol-1"
            ><span class="visually-hidden">Toggle navigation</span><span
                class="navbar-toggler-icon"
            /></button
        >
        <div
            class="collapse navbar-collapse"
            id="navcol-1"
            style="margin-right: -211px;margin-left: -229px;padding-left: 229px;padding-right: 212px;"
        >
            <ul class="navbar-nav mx-auto">
                <li class="nav-item">
                    <a class="nav-link active" href="/" use:link>Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link active" href="/wi-fi" use:link>Wi-Fi</a>
                </li>
                <li class="nav-item" />
                <li class="nav-item">
                    <a class="nav-link active" href="/fibra" use:link>Fibra</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link active" href="/voip" use:link>VoIP</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link active" href="/iot" use:link>Iot</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link active" href="/software" use:link
                        >Software</a
                    >
                </li>
            </ul>
            <a class="btn btn-primary shadow" role="button" href="login.html"
                >AREA CLIENTI</a
            >
        </div>
    </div>
</nav>

<Router {routes} />

<footer
    class="text-black text-bg-light page-footer"
    style="padding-top: 186px;"
>
    <div class="container">
        <div class="row">
            <div class="col-6 col-md-3">
                <img
                    src="assets/img/brands/LIRS_file-04.svg"
                    width="100"
                    height="72"
                    style="padding-left: 0px;margin-left: -22px;"
                    alt="lirs"
                />
                <h4>LIRS SRL</h4>
                <ul class="footer-links">
                    <li>Sede: Piazza Antonio Staffa, 10&nbsp;</li>
                    <li>87040 Mongrassano (CS)</li>
                    <li>P.IVA: IT 03385550789</li>
                    <li>RAE: CS-2231826</li>
                    <li>ROC: 27032</li>
                </ul>
            </div>
            <div class="col-6 col-md-3">
                <h4>Connettività</h4>
                <ul class="footer-links">
                    <li><a href="/fibra" use:link>Fibra</a></li>
                    <li><a href="/wi-fi" use:link>Wireless</a></li>
                    <li><a href="#">Fwa</a></li>
                    <li><a href="#">Attivazione</a></li>
                    <li />
                </ul>
                <h4>VoIP</h4>
                <ul class="footer-links">
                    <li><a href="#">Centralino in Cloud&nbsp;</a></li>
                    <li><a href="#">Solo VoIP</a></li>
                    <li><a href="#">Internet e Telefono</a></li>
                    <li><a href="#">Tariffe</a></li>
                    <li><a href="#">Attivazione</a></li>
                </ul>
            </div>
            <div class="col-6 col-md-3">
                <h4>Hosting</h4>
                <ul class="footer-links">
                    <li><a href="#">Hosting Base</a></li>
                    <li><a href="#">Hosting Pro</a></li>
                    <li><a href="#">Hosting Node</a></li>
                    <li><a href="#">Hosting PHP</a></li>
                </ul>
                <h4>VPS</h4>
                <ul class="footer-links">
                    <li><a href="#">VCs1</a></li>
                    <li><a href="#">VCs2</a></li>
                    <li><a href="#">VCs2 PRO</a></li>
                    <li><a href="#">VCs4</a></li>
                    <li><a href="#">VCs8</a></li>
                    <li><a class="text-bg-primary" href="#">VEDI TUTTE</a></li>
                </ul>
            </div>
            <div class="col-6 col-md-3">
                <h4>HOTSPOT</h4>
                <ul class="footer-links">
                    <li><a href="#">H-Spot-1</a></li>
                    <li><a href="#">H-Spot-2</a></li>
                    <li><a href="#">H-Spot-3</a></li>
                    <li><a href="#">H-Spot-4</a></li>
                    <li><a href="#">H-Spot-5</a></li>
                </ul>
                <h4>Iot Solution</h4>
                <ul class="footer-links">
                    <li><a href="#">Presino Cloud</a></li>
                    <li><a href="#">Contadino in cloud</a></li>
                    <li><a href="#">Soluzioni COSTUM</a></li>
                </ul>
            </div>
        </div>
        <p class="text-primary">Tutto è connesso.</p>
        <hr />
        <div class="footer-legal">
            <div class="float-md-end region">
                <a href="#">Powered by LIRS-Enterprise Solution</a>
            </div>
            <div class="d-inline-block copyright">
                <p class="d-inline-block">
                    Copyright © 2023. tutti i diritti riservati.
                </p>
            </div>
            <div class="d-inline-block legal-links">
                <div class="d-inline-block item">
                    <h5>Privacy Policy</h5>
                </div>
                <div class="d-inline-block item">
                    <h5>Termini e Condizioni</h5>
                </div>
                <div class="d-inline-block item" />
            </div>
        </div>
    </div>
</footer>
